var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-callback"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("\n    授权处理中...\n  ")]):(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("\n    授权失败: "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-044820c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alipaylogin/AuthCallback.vue
// module id = null
// module chunks = 